import React, { useState, useRef, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import './chatbotui.css';
import botIcon from '../../assets/img/asistente.png';
import { FaArrowUp, FaFileExcel, FaChartLine, FaSpinner, FaLightbulb, FaGlobe, FaGlobeAmericas, FaPaperclip, FaTimes } from 'react-icons/fa';
import * as XLSX from 'xlsx';
import { useAuthenticator } from '@aws-amplify/ui-react';
import Modal from 'react-modal';
import 'chart.js/auto';
import ChartWithControls from '../chatbotui/chartwithcontrols';
import DataTable from './datatable'; // Importar el nuevo componente
import { BedrockAgentRuntimeClient, InvokeAgentCommand } from "@aws-sdk/client-bedrock-agent-runtime";
import { fromCognitoIdentityPool } from "@aws-sdk/credential-providers";
import { fetchAuthSession } from 'aws-amplify/auth';
import config from '../../amplifyconfiguration.json';
import { SignatureV4 } from "@aws-sdk/signature-v4";
import { HttpRequest } from "@aws-sdk/protocol-http";
import { Sha256 } from "@aws-crypto/sha256-browser";
import { v4 as uuidv4 } from 'uuid';
import { FaEllipsisV, FaBookmark } from 'react-icons/fa';
import SQLValidator from '../../utils/SQLValidator'; // 👈 Importación desde utils
import {
    buildWebSearchPrompt, buildSuggestedQuestionsPrompt, buildConsultClaudePrompt, buildSQLPrompt
} from '../../utils/prompts';

import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';
import { tomorrow } from 'react-syntax-highlighter/dist/esm/styles/prism';


const Chatbotui = ({ isSidebarVisible }) => {


    const { id_conversation } = useParams();
    const [response, setResponse] = useState("");
    const { user } = useAuthenticator((context) => [context.user]); // Get the user  const { user } = useAuthenticator((context) => [context.user]); // Get the user
    const id_user = user.username
    const [message, setMessage] = useState('');
    const [messages, setMessages] = useState([]);
    const [loading, setLoading] = useState(false); // Indicador de carga
    const [modalIsOpen, setModalIsOpen] = useState(false); // Estado para controlar el modal
    const [queryData, setQueryData] = useState(null);
    const messageInputRef = useRef(null);
    const messagesEndRef = useRef(null);
    const [loadingMessage, setLoadingMessage] = useState('Analyzing price trends...'); // Estado para almacenar el mensaje de carga

    // Estados para búsqueda web
    const [webSearchEnabled, setWebSearchEnabled] = useState(false);
    const [webSearchLoading, setWebSearchLoading] = useState(false);

    // Nuevos estados para manejar la carga en segundo plano de la visualización
    const [vizLoading, setVizLoading] = useState({}); // Estado para seguir qué mensajes están cargando su visualización
    const [vizData, setVizData] = useState({}); // Estado para almacenar datos precargados de visualización por mensaje

    const [activeOptionsMenu, setActiveOptionsMenu] = useState(null);
    const [savingConsult, setSavingConsult] = useState(false);

    /* --------------- NUEVOS STATES Y REFS --------------- */
    const [imageFile, setImageFile] = useState(null);
    const [imagePreview, setImagePreview] = useState(null);
    const [imageModeEnabled, setImageModeEnabled] = useState(false);
    const imageInputRef = useRef(null);

    // Agregar este estado
    const [hoverButtonIndex, setHoverButtonIndex] = useState(null);

    // Busca esta línea en el estado y reemplázala:
    const [suggestedQuestions, setSuggestedQuestions] = useState([
        "¿Cuál es la productividad por especialidad médica en los últimos 6 meses?",
        "¿Cómo se distribuye la facturación por centro sanitario y tipo de paciente?",
        "¿Cuáles son los médicos con mayor volumen de estudios por especialidad?",
        "¿Qué prestaciones médicas generan mayor facturación por centro?",
        "¿Cuáles son las tendencias de estudios realizados por mes en 2024-2025?",
        "¿Cómo varía la productividad entre pacientes externos e internos?"
    ]);

    const [loadingSuggestions, setLoadingSuggestions] = useState(false);

    const baseURL = process.env.REACT_APP_BASE_URL;
    const baseURLBD = process.env.REACT_APP_BD;
    const endpoint_mes = '/get_messages_conversation';
    const endpoint_add_message = '/add_message';
    const endpoint_get_sql = '/get_query';
    const endpoint_executeSQL = '/get_rds';
    const AGENT_ID = "GCZBIASLN1";
    const AGENT_ALIAS_ID = "AUK75S7MLV";
    const endpoint_add_saved_consult = '/add_saved_consult';
    const OPENAI_API_KEY = "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"

    const loadingPhrases = [
        "Without data, you're just another person with an opinion. – W. Edwards Deming",
        "In the end, we are all determined by data. – Tim O'Reilly",
        "In God we trust. All others must bring data. – W. Edwards Deming",
        "Data is the new oil. – Clive Humby",
        "The goal is to turn data into information, and information into insight. – Carly Fiorina",
        "Numbers have an important story to tell. They rely on you to give them a clear and convincing voice. – Stephen Few",
        "Torture the data, and it will confess to anything. – Ronald Coase",
        "Data beats emotions. – Sean Rad",
        "You can have data without information, but you cannot have information without data. – Daniel Keys Moran",
        "Big data is at the foundation of all the megatrends that are happening today. – Chris Lynch",
        "Information is the oil of the 21st century, and analytics is the combustion engine. – Peter Sondergaard",
        "The world is one big data problem. – Andrew McAfee",
        "Data is a precious thing and will last longer than the systems themselves. – Tim Berners-Lee",
        "If you torture the data long enough, it will confess to anything. – Darrell Huff",
        "The most valuable commodity I know of is information. – Gordon Gekko (Wall Street)",
        "Data really powers everything that we do. – Jeff Weiner",
    ];

    /* --------------- ---------------  ---------------  Interfaz  ---------------  --------------- --------------- */

    // Función para manejar el clic en el botón de opciones
    const handleOptionsClick = (index, e) => {
        e.stopPropagation(); // Evitar propagación
        setActiveOptionsMenu(activeOptionsMenu === index ? null : index);
    };

    // Cerrar el menú de opciones si se hace clic fuera de él
    useEffect(() => {
        const handleClickOutside = () => {
            setActiveOptionsMenu(null);
        };

        document.addEventListener('click', handleClickOutside);
        return () => {
            document.removeEventListener('click', handleClickOutside);
        };
    }, []);



    // Cambiar la frase 
    useEffect(() => {

        const intervalId = setInterval(() => {
            const randomIndex = Math.floor(Math.random() * loadingPhrases.length);
            setMessages(prevMessages => prevMessages.map(msg =>
                msg.temp ? { ...msg, content: <span className="thinking-dots">{loadingPhrases[randomIndex]}</span> } : msg
            ));
        }, 4000);

        // Limpiar el intervalo cuando se desmonte el componente
        return () => clearInterval(intervalId);
    }, [loadingPhrases]);

    useEffect(() => {
        return () => {
            // Limpiar URL al desmontar el componente
            if (imagePreview) {
                URL.revokeObjectURL(imagePreview);
            }
        };
    }, [imagePreview]);
    // Funciones de input
    const adjustTextareaHeight = (element) => {
        element.style.height = 'auto';
        element.style.height = (element.scrollHeight) + 'px';
    };

    const handleTextareaChange = (e) => {
        setMessage(e.target.value);
        adjustTextareaHeight(e.target);
    };

    const addMessage = (author, content, type = 'text', data = null, temp = false) => {
        const newMessage = { author, content, type, data, id: Date.now(), temp };
        setMessages(prevMessages => [...prevMessages, newMessage]);
    };

    // Agregar esta función dentro del componente Chatbotui
    const scrollToBottom = () => {
        // Asegurarse de que messagesEndRef exista y tenga un elemento actual
        if (messagesEndRef.current) {
            messagesEndRef.current.scrollIntoView({ behavior: 'smooth' });
        }
    };

    //  Para scroll automático al cargar mensajes iniciales
    useEffect(() => {
        const fetchMessages = async () => {
            if (id_conversation) {
                try {
                    // Código existente para recuperar mensajes...

                    // Después de establecer los mensajes, hacer scroll al final
                    if (response && response.messages) {
                        setMessages(response.messages);
                        // Programar el scroll para después de que los mensajes se rendericen
                        setTimeout(scrollToBottom, 100);
                    } else {
                        console.warn('No messages data in response:', response);
                        setMessages([]);
                    }
                } catch (error) {
                    console.error('Error fetching messages:', error);
                    setMessages([]);
                }
            }
        };

        fetchMessages();
    }, [id_conversation, config]);

    // 3. Agregar un useEffect adicional para monitorear cambios en los mensajes
    useEffect(() => {
        // Hacer scroll hacia abajo cuando cambia la lista de mensajes
        if (messages.length > 0) {
            scrollToBottom();
        }
    }, [messages.length]); // Solo se dispara cuando cambia el número de mensajes

    // Agregar después de tus otros useEffect
    useEffect(() => {
        // Función para manejar el evento de consulta guardada seleccionada
        const handleSavedQueryEvent = (event) => {
            const { query } = event.detail;
            //console.log("Chatbotui: Evento de consulta guardada recibido:", query);

            // Actualizar el estado del mensaje
            setMessage(query);

            // Ajustar la altura del textarea si está disponible
            setTimeout(() => {
                const textarea = messageInputRef.current || document.querySelector('.message-input');
                if (textarea) {
                    textarea.style.height = 'auto';
                    textarea.style.height = (textarea.scrollHeight) + 'px';
                    textarea.focus();
                }
            }, 50);
        };

        // Escuchar el evento personalizado
        document.addEventListener('savedQuerySelected', handleSavedQueryEvent);

        // Limpiar el listener cuando el componente se desmonte
        return () => {
            document.removeEventListener('savedQuerySelected', handleSavedQueryEvent);
        };
    }, []); // Sin dependencias para que se configure una sola vez

    // También puedes añadir un useEffect adicional para manejar el cambio de textarea directamente
    useEffect(() => {
        const handleDirectInputChange = (event) => {
            if (event.target.matches('.message-input')) {
                // Si el valor cambió desde fuera de React, sincronizar con el estado
                setMessage(event.target.value);
            }
        };

        // Escuchar cambios de input a nivel de documento
        document.addEventListener('input', handleDirectInputChange);

        return () => {
            document.removeEventListener('input', handleDirectInputChange);
        };
    }, []);

    // Agregar estas funciones
    const handleButtonMouseEnter = (index) => {
        setHoverButtonIndex(index);
    };

    const handleButtonMouseLeave = () => {
        setHoverButtonIndex(null);
    };

    // Este código se debe añadir después de las declaraciones de estado y antes del renderizado, carrusel
    const useDraggableCarousel = () => {
        const carouselRef = useRef(null);
        const isDragging = useRef(false);
        const startX = useRef(0);
        const scrollLeft = useRef(0);

        const handleMouseDown = (e) => {
            if (!carouselRef.current) return;
            isDragging.current = true;
            startX.current = e.pageX - carouselRef.current.offsetLeft;
            scrollLeft.current = carouselRef.current.scrollLeft;
            carouselRef.current.style.cursor = 'grabbing';
        };

        const handleMouseUp = () => {
            if (!carouselRef.current) return;
            isDragging.current = false;
            carouselRef.current.style.cursor = 'grab';
        };

        const handleMouseLeave = () => {
            if (isDragging.current) {
                isDragging.current = false;
                if (carouselRef.current) {
                    carouselRef.current.style.cursor = 'grab';
                }
            }
        };

        const handleMouseMove = (e) => {
            if (!isDragging.current || !carouselRef.current) return;
            e.preventDefault();
            const x = e.pageX - carouselRef.current.offsetLeft;
            const walk = (x - startX.current) * 1.5; // Multiplicador de velocidad
            carouselRef.current.scrollLeft = scrollLeft.current - walk;
        };

        // Manejo de eventos táctiles para dispositivos móviles
        const handleTouchStart = (e) => {
            if (!carouselRef.current) return;
            isDragging.current = true;
            startX.current = e.touches[0].pageX - carouselRef.current.offsetLeft;
            scrollLeft.current = carouselRef.current.scrollLeft;
        };

        const handleTouchMove = (e) => {
            if (!isDragging.current || !carouselRef.current) return;
            const x = e.touches[0].pageX - carouselRef.current.offsetLeft;
            const walk = (x - startX.current) * 1.5;
            carouselRef.current.scrollLeft = scrollLeft.current - walk;
        };

        const handleTouchEnd = () => {
            isDragging.current = false;
        };


        useEffect(() => {
            const carousel = carouselRef.current;
            if (!carousel) return;

            let isDown = false;
            let startX;
            let scrollLeft;

            // Eventos básicos para el arrastre (drag & drop)
            const mouseDown = (e) => {
                isDown = true;
                carousel.style.cursor = 'grabbing';
                startX = e.pageX - carousel.offsetLeft;
                scrollLeft = carousel.scrollLeft;
            };

            const mouseUp = () => {
                isDown = false;
                carousel.style.cursor = 'grab';
            };

            const mouseLeave = () => {
                isDown = false;
                carousel.style.cursor = 'grab';
            };

            const mouseMove = (e) => {
                if (!isDown) return;
                e.preventDefault();
                const x = e.pageX - carousel.offsetLeft;
                const walk = (x - startX) * 1.5; // Velocidad de desplazamiento
                carousel.scrollLeft = scrollLeft - walk;
            };

            // Soporte para dispositivos táctiles
            const touchStart = (e) => {
                isDown = true;
                startX = e.touches[0].pageX - carousel.offsetLeft;
                scrollLeft = carousel.scrollLeft;
            };

            const touchMove = (e) => {
                if (!isDown) return;
                const x = e.touches[0].pageX - carousel.offsetLeft;
                const walk = (x - startX) * 1.5;
                carousel.scrollLeft = scrollLeft - walk;
            };

            const touchEnd = () => {
                isDown = false;
            };

            // Añadir event listeners
            carousel.addEventListener('mousedown', mouseDown);
            carousel.addEventListener('mouseup', mouseUp);
            carousel.addEventListener('mouseleave', mouseLeave);
            carousel.addEventListener('mousemove', mouseMove);

            carousel.addEventListener('touchstart', touchStart);
            carousel.addEventListener('touchmove', touchMove);
            carousel.addEventListener('touchend', touchEnd);

            // Limpieza
            return () => {
                carousel.removeEventListener('mousedown', mouseDown);
                carousel.removeEventListener('mouseup', mouseUp);
                carousel.removeEventListener('mouseleave', mouseLeave);
                carousel.removeEventListener('mousemove', mouseMove);

                carousel.removeEventListener('touchstart', touchStart);
                carousel.removeEventListener('touchmove', touchMove);
                carousel.removeEventListener('touchend', touchEnd);
            };
        }, [suggestedQuestions]);

        return carouselRef;
    };
    const carouselRef = useDraggableCarousel();

    // Manejador para copiar pregunta sugerida al input
    const handleSuggestedQuestion = (question) => {
        setMessage(question);
        if (messageInputRef.current) {
            messageInputRef.current.focus();
            adjustTextareaHeight(messageInputRef.current);
        }
    };

    // Función para alternar el estado de búsqueda web
    const toggleWebSearch = () => {
        setWebSearchEnabled(!webSearchEnabled);
    };

    // Función de procesamiento de imágenes 
    const handleImageChange = (e) => {
        const file = e.target.files?.[0];
        if (file) {
            // Validar tipo de archivo
            if (!file.type.startsWith('image/')) {
                alert('Por favor selecciona un archivo de imagen válido.');
                return;
            }

            // Validar tamaño (máximo 10MB)
            if (file.size > 10 * 1024 * 1024) {
                alert('El archivo es demasiado grande. Máximo 10MB.');
                return;
            }

            // Limpiar URL anterior si existe
            if (imagePreview) {
                URL.revokeObjectURL(imagePreview);
            }

            setImageFile(file);
            setImagePreview(URL.createObjectURL(file));
            setImageModeEnabled(true);
            messageInputRef.current?.focus();
        }
    };

    const clearImage = () => {
        // Limpiar URL del objeto para evitar memory leaks
        if (imagePreview) {
            URL.revokeObjectURL(imagePreview);
        }

        setImageFile(null);
        setImagePreview(null);
        setImageModeEnabled(false);

        // Limpiar el input file
        if (imageInputRef.current) {
            imageInputRef.current.value = '';
        }
    };
    /* ---------------  ---------------  --------------- Funciones de mensajes BD ---------------  ---------------  --------------- */

    // Función para guardar una consulta
    const handleSaveConsult = async (content) => {
        try {
            setSavingConsult(true);
            const authenticatedRequest = await createAuthenticatedRequest(config);
            const url = `${baseURL}${endpoint_add_saved_consult}`;

            const response = await authenticatedRequest(
                url,
                'POST',
                {
                    id_user: id_user,
                    consult: content
                }
            );

            if (response && response.id_saved) {
                // Emitir un evento para notificar que se ha guardado una consulta
                const customEvent = new CustomEvent('querySaved', {
                    detail: { id_saved: response.id_saved },
                    bubbles: true,
                    cancelable: true
                });
                document.dispatchEvent(customEvent);

                // Mostrar confirmación con toast o alert

                setActiveOptionsMenu(null);
            } else {
                throw new Error("No se recibió confirmación del servidor");
            }
        } catch (error) {
            console.error("Error al guardar la consulta:", error);

        } finally {
            setSavingConsult(false);
        }
    };

    // Función para guardar una consulta
    const addMessageBD = async (id_conversation, id_user, message, author, id_message) => {
        try {
            // Crear el request autenticado
            const authenticatedRequest = await createAuthenticatedRequest(config);

            // Construir la URL
            const url = `${baseURL}${endpoint_add_message}`;

            // Hacer la petición POST autenticada
            const response = await authenticatedRequest(
                url,
                'POST',
                {
                    id_user: id_user,
                    id_conversation: id_conversation,
                    content: message,
                    author: author,
                    id_message: id_message
                }
            );

            return response.id_message

        } catch (error) {

            console.error('Error creating new conversation:', error);
            return "None"
        }
    };

    // Función para obtener una consultas
    useEffect(() => {
        const fetchMessages = async () => {
            if (id_conversation) {  // Verificamos que exista id_conversation
                try {
                    // Crear el request autenticado usando la configuración
                    const authenticatedRequest = await createAuthenticatedRequest(config);

                    // Construir la URL completa con el query parameter
                    const url = `${baseURL}${endpoint_mes}?id_conversation=${encodeURIComponent(id_conversation)}`;

                    // Para debug
                    /* //console.log('Request URL:', url); */

                    // Hacer la petición autenticada
                    const response = await authenticatedRequest(
                        url,
                        'GET',
                        null
                    );

                    /* //console.log('Response:', response); */

                    // Modifica la parte donde seteas los mensajes en el useEffect
                    if (response && response.messages) {
                        // Ordena los mensajes por fecha (asumiendo que tienes un campo created_at o timestamp)
                        const sortedMessages = response.messages.sort((a, b) => {
                            return new Date(a.created_at || a.timestamp || 0) - new Date(b.created_at || b.timestamp || 0);
                        });
                        setMessages(sortedMessages);
                    } else {
                        console.warn('No messages data in response:', response);
                        setMessages([]);
                    }
                } catch (error) {
                    console.error('Error fetching messages:', error);
                    setMessages([]);
                }
            }
        };

        fetchMessages();
    }, [id_conversation, config]); // Añadido config a las dependencias


    // Función para actualizar una consulta
    const updateMessageBD = async (id_message, query_sql) => {
        try {
            // Crear el request autenticado
            const authenticatedRequest = await createAuthenticatedRequest(config);

            // Construir la URL
            const url = `${baseURL}/update_query_sql`;

            // Hacer la petición POST autenticada
            const response = await authenticatedRequest(
                url,
                'POST',
                {
                    id_message: id_message,
                    query_sql: query_sql
                }
            );

            return response.message;

        } catch (error) {
            console.error('Error updating query_sql:', error);
            return "Failed to update query_sql";
        }
    };

    /* ---------------  ---------------  --------------- Funciones complementarias (Web, imágenes, preguntas sugeridas, errores)  ---------------  --------------- --------------- */

    // Funcion de búsqueda web
    const performWebSearch = async (query) => {
        const apiKey = "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";

        try {
            setWebSearchLoading(true);

            const content = buildWebSearchPrompt(query);

            // Usar el mismo patrón exacto que sendMessageToClaude pero con herramientas de búsqueda web
            const response = await fetch("https://api.anthropic.com/v1/messages", {
                method: "POST",
                headers: {
                    "x-api-key": apiKey,
                    "anthropic-version": "2023-06-01",
                    "content-type": "application/json",
                    "anthropic-dangerous-direct-browser-access": "true"
                },
                body: JSON.stringify({
                    model: "claude-sonnet-4-20250514",
                    max_tokens: 1500,
                    tools: [
                        {
                            type: "web_search_20250305",
                            name: "web_search",
                            max_uses: 3,
                            user_location: {
                                type: "approximate",
                                city: "Mexico City",
                                region: "Ciudad de Mexico",
                                country: "MX",
                                timezone: "America/Mexico_City"
                            }
                        }
                    ],
                    messages: [
                        {
                            role: "user",
                            content: content
                        }
                    ]
                })
            })
                .then((response) => {
                    if (!response.ok) {
                        console.error('Error en la API de Claude:', response.statusText);
                        return null;
                    }
                    return response.json();
                })
                .then((data) => {
                    if (!data || !data.content || data.content.length === 0) {
                        return "No se pudo obtener información de búsqueda web.";
                    }

                    // Extraer el contenido de la respuesta y las citas si existen
                    let webSearchResults = "";
                    let citations = [];

                    for (const contentBlock of data.content) {
                        if (contentBlock.type === "text") {
                            webSearchResults += contentBlock.text;

                            // Agregar citas si existen
                            if (contentBlock.citations && contentBlock.citations.length > 0) {
                                citations = citations.concat(contentBlock.citations);
                            }
                        }
                    }

                    // Agregar información de las fuentes al final si hay citas
                    if (citations.length > 0) {
                        webSearchResults += "\n\nFuentes consultadas:";
                        citations.forEach((citation, index) => {
                            if (citation.url && citation.title) {
                                webSearchResults += `\n${index + 1}. ${citation.title} - ${citation.url}`;
                            }
                        });
                    }

                    console.log("Resultados de búsqueda web:", webSearchResults);
                    console.log("Uso de tokens:", data.usage);

                    return webSearchResults;
                })
                .catch((error) => {
                    console.error('Error haciendo la petición de búsqueda web:', error);
                    return `Error al realizar búsqueda web: ${error.message}`;
                });

            return response;

        } catch (error) {
            console.error('Error en búsqueda web:', error);
            throw new Error(`Error al realizar búsqueda web: ${error.message}`);
        } finally {
            setWebSearchLoading(false);
        }
    };

    // Función de procesamiento de imágenes
    const performImageAnalysis = async (file, userPrompt = '') => {
        console.log('Iniciando análisis de imagen...', {
            fileName: file.name,
            fileSize: file.size,
            fileType: file.type,
            userPrompt: userPrompt
        });

        try {
            // Verificar que tenemos API key
            const CLAUDE_API_KEY = process.env.REACT_APP_CLAUDE_API_KEY || "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";

            if (!CLAUDE_API_KEY || CLAUDE_API_KEY === 'tu-api-key-aqui') {
                throw new Error('API key de Claude no configurada');
            }

            // Convertir imagen a base64
            const base64 = await new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.onload = () => {
                    try {
                        const result = reader.result;
                        if (typeof result === 'string') {
                            const base64Data = result.split(',')[1];
                            if (!base64Data) {
                                reject(new Error('Error al extraer datos base64'));
                                return;
                            }
                            resolve(base64Data);
                        } else {
                            reject(new Error('Formato de archivo no válido'));
                        }
                    } catch (error) {
                        reject(error);
                    }
                };
                reader.onerror = () => reject(new Error('Error al leer el archivo'));
                reader.readAsDataURL(file);
            });

            // Crear prompt mejorado que incluye el contexto del usuario
            let analysisPrompt = `Analiza esta imagen en el contexto de análisis de datos de negocio. `;

            if (userPrompt && userPrompt.trim()) {
                analysisPrompt += `El usuario quiere: "${userPrompt}". `;
                analysisPrompt += `Describe la imagen de manera que sea útil para responder a esta consulta de negocio. `;
                analysisPrompt += `Si la imagen contiene datos (gráficos, tablas, números), extrae esa información. `;
                analysisPrompt += `Si la imagen muestra procesos de negocio, identifica patrones relevantes. `;
                analysisPrompt += `Proporciona una interpretación que ayude a responder la consulta del usuario.`;
            } else {
                analysisPrompt += `Describe la imagen enfocándote en cualquier información de negocio, datos, `;
                analysisPrompt += `gráficos, tablas, procesos o elementos que puedan ser relevantes para análisis empresarial.`;
            }

            console.log('Enviando solicitud a Claude API...');

            // Hacer la petición a Claude
            const response = await fetch('https://api.anthropic.com/v1/messages', {
                method: 'POST',
                headers: {
                    'x-api-key': CLAUDE_API_KEY,
                    'anthropic-version': '2023-06-01',
                    'content-type': 'application/json',
                    'anthropic-dangerous-direct-browser-access': 'true'
                },
                body: JSON.stringify({
                    model: 'claude-3-5-sonnet-20241022',
                    max_tokens: 1500,
                    messages: [
                        {
                            role: 'user',
                            content: [
                                {
                                    type: 'image',
                                    source: {
                                        type: 'base64',
                                        media_type: file.type,
                                        data: base64
                                    }
                                },
                                {
                                    type: 'text',
                                    text: analysisPrompt
                                }
                            ]
                        }
                    ]
                })
            });

            if (!response.ok) {
                let errorMessage = `Error HTTP: ${response.status}`;

                switch (response.status) {
                    case 401:
                        errorMessage = 'API key inválida o no autorizada';
                        break;
                    case 400:
                        errorMessage = 'Solicitud inválida. Verifica el formato de la imagen';
                        break;
                    case 429:
                        errorMessage = 'Límite de solicitudes excedido. Intenta de nuevo en unos minutos';
                        break;
                    case 500:
                        errorMessage = 'Error del servidor de Claude. Intenta de nuevo más tarde';
                        break;
                }

                throw new Error(errorMessage);
            }

            const data = await response.json();
            const analysisText = data.content?.[0]?.text;

            if (!analysisText) {
                throw new Error('Respuesta de Claude sin contenido de texto');
            }

            return analysisText;

        } catch (error) {
            console.error('Error completo en análisis de imagen:', error);
            throw error;
        }
    };
    // Nueva función para obtener preguntas sugeridas basadas en la pregunta actual
    const getSuggestedQuestions = async (previousQuestion, botResponse) => {
        setLoadingSuggestions(true);
        const apiKey = "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";

        // Esquema de la base de datos para proporcionar contexto
        // Busca esta sección en getSuggestedQuestions y reemplázala:

        // Mensaje para Claude
        const prompt = buildSuggestedQuestionsPrompt(previousQuestion, botResponse);

        try {
            const response = await fetch("https://api.anthropic.com/v1/messages", {
                method: "POST",
                headers: {
                    "x-api-key": apiKey,
                    "anthropic-version": "2023-06-01",
                    "content-type": "application/json",
                    "anthropic-dangerous-direct-browser-access": "true"
                },
                body: JSON.stringify({
                    model: "claude-sonnet-4-20250514",
                    max_tokens: 1000,
                    messages: [{ role: "user", content: prompt }]
                })
            });

            if (!response.ok) {
                console.error('Error en la API de Claude:', response.statusText);
                // Si hay error, mantenemos las preguntas actuales
                setLoadingSuggestions(false);
                return;
            }

            const data = await response.json();
            const responseText = data.content[0].text;

            try {
                // Intentar analizar las preguntas como JSON
                const newQuestions = JSON.parse(responseText);
                if (Array.isArray(newQuestions) && newQuestions.length >= 3) {
                    // Solo tomamos las primeras 3 preguntas
                    setSuggestedQuestions(newQuestions.slice(0, 3));
                } else {
                    console.warn('Formato inesperado de preguntas:', responseText);
                    // Si el formato no es el esperado, extraemos manualmente
                    const extractedQuestions = responseText.match(/"([^"]+)"/g);
                    if (extractedQuestions && extractedQuestions.length >= 3) {
                        const cleanQuestions = extractedQuestions.slice(0, 3).map(q => q.replace(/"/g, ''));
                        setSuggestedQuestions(cleanQuestions);
                    }
                }
            } catch (parseError) {
                console.error('Error al analizar respuesta JSON:', parseError);

                // Intento de extracción con expresiones regulares como respaldo
                const extractedQuestions = responseText.match(/"([^"]+)"/g);
                if (extractedQuestions && extractedQuestions.length >= 3) {
                    const cleanQuestions = extractedQuestions.slice(0, 3).map(q => q.replace(/"/g, ''));
                    setSuggestedQuestions(cleanQuestions);
                }
            }
        } catch (error) {
            console.error('Error al obtener preguntas sugeridas:', error);
        } finally {
            setLoadingSuggestions(false);
        }
    };

    // Nueva función para cachar errores
    const consultClaude = async (originalQuery, errorMessage) => {
        const apiKey = "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"; // Asegúrate de añadir esta variable de entorno

        // Crear el mensaje para Claude con contexto del error
        // Busca esta sección en consultClaude y reemplázala:
        const content = buildConsultClaudePrompt(originalQuery, errorMessage);
        try {
            const response = await fetch("https://api.anthropic.com/v1/messages", {
                method: "POST",
                headers: {
                    "x-api-key": apiKey,
                    "anthropic-version": "2023-06-01",
                    "content-type": "application/json",
                    "anthropic-dangerous-direct-browser-access": "true"
                },
                body: JSON.stringify({
                    model: "claude-sonnet-4-20250514",
                    max_tokens: 1000,
                    messages: [
                        {
                            role: "user",
                            content: content
                        }
                    ]
                })
            });

            if (!response.ok) {
                console.error('Error en la API de Claude:', response.statusText);
                return null;
            }

            const data = await response.json();
            return data.content[0].text;
        } catch (error) {
            console.error('Error haciendo la petición a Claude:', error);
            return null;
        }
    };

    /* ---------------  ---------------  --------------- Funciones para el modulo de visualización ---------------  ---------------  --------------- */

    // Nueva función para cargar la visualización en segundo plano
    const loadVisualizationInBackground = async (id_message, initialQuerySQL, userContent, botContent) => {
        try {
            // Crear instancia del validador
            const validator = new SQLValidator();
            let finalQuerySQL = initialQuerySQL;
            let errorMessage = "";
            let attempts = 0;
            const MAX_ATTEMPTS = 2;

            // Estructura base para datos de error
            const errorDataStructure = {
                data: [],
                columns: {},
                query: finalQuerySQL || "",
                column_types: {},
                hasError: true,
                error: "No se puede generar la gráfica. Por favor, intenta reformular tu pregunta."
            };

            // Si no hay consulta o es "Vacio", obtenerla del agente
            if (!finalQuerySQL || finalQuerySQL === "Vacio") {
                try {
                    let mensajes_anteriores = await getQuery(id_message);
                    //console.log("MENSAJES ANTERIORES (BG):", mensajes_anteriores);
                    let respuestaClaude = await sendMessageToClaude(mensajes_anteriores, userContent, botContent);

                    finalQuerySQL = respuestaClaude?.content?.[0]?.text || "";
                    if (!finalQuerySQL) {
                        throw new Error("No se pudo generar una consulta SQL válida");
                    }

                    await updateMessageBD(id_message, finalQuerySQL);
                    //console.log("Consulta generada en segundo plano:", finalQuerySQL);
                } catch (genError) {
                    console.error("Error generando consulta en segundo plano:", genError);
                    setVizData(prev => ({
                        ...prev,
                        [id_message]: {
                            ...errorDataStructure,
                            error: "No se pudo generar la consulta SQL. Por favor, intenta de nuevo con otra pregunta."
                        }
                    }));
                    setVizLoading(prev => ({
                        ...prev,
                        [id_message]: false
                    }));
                    return;
                }
            }

            // Proceso iterativo de validación, corrección y ejecución
            while (attempts < MAX_ATTEMPTS) {
                attempts++;

                try {
                    // Limpiar y validar SQL
                    finalQuerySQL = validator.cleanMarkdown(finalQuerySQL);
                    let validationResult = validator.validate(finalQuerySQL);

                    if (!validationResult.valid || errorMessage) {
                        console.warn(`Intento #${attempts} (BG): Validación SQL con errores:`, validationResult.errors, "Error previo:", errorMessage);

                        // Corregir errores
                        const { sql: correctedSQL, wasFixed, fixes } = validator.fixQuery(finalQuerySQL, errorMessage);

                        if (wasFixed) {
                            //console.log(`Consulta corregida en intento #${attempts} (BG):`, correctedSQL);
                            //console.log("Correcciones aplicadas (BG):", fixes);
                            finalQuerySQL = correctedSQL;
                        } else if (errorMessage) {
                            // Si hay error pero no pudimos corregirlo, terminar el loop
                            console.error("No se pudo corregir el error (BG):", errorMessage);
                            break;
                        }
                    }

                    // Ejecutar la consulta SQL corregida
                    //console.log(`Ejecutando consulta en segundo plano (intento #${attempts}):`, finalQuerySQL);

                    let records = await executeSQL(finalQuerySQL);

                    // 🔍 VALIDACIÓN MEJORADA: Verificar estructura de datos
                    const validateDataStructure = (records) => {
                        console.log("🔍 DEBUG - Validando estructura de datos:", {
                            recordsExists: !!records,
                            recordsType: typeof records,
                            hasData: !!records?.data,
                            dataType: typeof records?.data,
                            isDataArray: Array.isArray(records?.data),
                            dataLength: records?.data?.length,
                            hasColumns: !!records?.columns,
                            columnsType: typeof records?.columns,
                            columnsKeys: records?.columns ? Object.keys(records.columns) : [],
                            hasError: !!records?.error,
                            error: records?.error
                        });

                        if (!records || typeof records !== 'object') {
                            return { isValid: false, error: "Datos no válidos recibidos del servidor" };
                        }

                        if (records.error) {
                            return { isValid: false, error: records.error };
                        }

                        if (!Array.isArray(records.data)) {
                            return { isValid: false, error: "Formato de datos incorrecto - se esperaba un array" };
                        }

                        if (!records.columns || typeof records.columns !== 'object') {
                            return { isValid: false, error: "Información de columnas faltante o inválida" };
                        }

                        return { isValid: true };
                    };

                    const validation = validateDataStructure(records);
                    console.log("🔍 DEBUG - Resultado de validación de estructura:", validation);

                    if (!validation.isValid) {
                        errorMessage = validation.error;
                        console.error(`🚨 DEBUG - Error de validación en intento #${attempts}:`, errorMessage);

                        // Si es el último intento, preparar mensaje amigable
                        if (attempts >= MAX_ATTEMPTS) {
                            let userFriendlyError = "No se puede generar la gráfica en este momento. ";

                            if (errorMessage.includes("operator does not exist")) {
                                userFriendlyError += "Hay un problema de compatibilidad entre tipos de datos.";
                            } else if (errorMessage.includes("timeout") || errorMessage.includes("exceeded")) {
                                userFriendlyError += "La consulta es demasiado compleja.";
                            } else if (errorMessage.includes("array")) {
                                userFriendlyError += "El formato de los datos no es el esperado.";
                            } else {
                                userFriendlyError += "Ha ocurrido un error al procesar la consulta.";
                            }

                            userFriendlyError += " Por favor, intenta reformular tu pregunta.";

                            console.log("🔍 DEBUG - Guardando error final:", userFriendlyError);

                            // Almacenar el error
                            setVizData(prev => ({
                                ...prev,
                                [id_message]: {
                                    ...errorDataStructure,
                                    query: finalQuerySQL,
                                    error: userFriendlyError
                                }
                            }));
                            break;
                        }

                        continue;
                    }


                    // Verificar si hay errores en la ejecución
                    if (records && records.error) {
                        errorMessage = records.error;
                        console.error(`Error al ejecutar SQL en segundo plano (intento #${attempts}):`, errorMessage);

                        // Si es el último intento, preparar mensaje amigable
                        if (attempts >= MAX_ATTEMPTS) {
                            let userFriendlyError = "No se puede generar la gráfica en este momento. ";

                            if (errorMessage.includes("operator does not exist")) {
                                userFriendlyError += "Hay un problema de compatibilidad entre tipos de datos.";
                            } else if (errorMessage.includes("timeout") || errorMessage.includes("exceeded")) {
                                userFriendlyError += "La consulta es demasiado compleja.";
                            } else {
                                userFriendlyError += "Ha ocurrido un error al procesar la consulta.";
                            }

                            userFriendlyError += " Por favor, intenta reformular tu pregunta.";

                            // Almacenar el error
                            setVizData(prev => ({
                                ...prev,
                                [id_message]: {
                                    ...errorDataStructure,
                                    query: finalQuerySQL,
                                    error: userFriendlyError
                                }
                            }));
                            break;
                        }

                        continue;
                    }

                    // Si llegamos aquí, la consulta se ejecutó sin errores
                    //console.log(`Consulta ejecutada con éxito en segundo plano en intento #${attempts}`);

                    // Validar que records tenga la estructura esperada
                    if (!records || !records.data || !Array.isArray(records.data)) {
                        throw new Error("La respuesta no tiene el formato esperado");
                    }

                    // Actualizar el mensaje con la consulta final
                    setMessages(prevMessages =>
                        prevMessages.map(msg =>
                            msg.id_message === id_message
                                ? { ...msg, query_sql: finalQuerySQL }
                                : msg
                        )
                    );

                    // Guardar datos de visualización
                    setVizData(prev => ({
                        ...prev,
                        [id_message]: {
                            data: records.data || [],
                            columns: records.columns || {},
                            query: finalQuerySQL,
                            column_types: records.column_types || {},
                            hasError: false
                        }
                    }));

                    // Marcar como completado
                    setVizLoading(prev => ({
                        ...prev,
                        [id_message]: false
                    }));
                    return;
                } catch (loopError) {
                    console.error(`Error en intento #${attempts} (BG):`, loopError);
                    errorMessage = loopError.message || "Error desconocido";

                    // Si es el último intento, guardar el error
                    if (attempts >= MAX_ATTEMPTS) {
                        setVizData(prev => ({
                            ...prev,
                            [id_message]: {
                                ...errorDataStructure,
                                error: "No se puede generar la gráfica. Por favor, intenta nuevamente."
                            }
                        }));
                    }
                }
            }

        } catch (error) {
            console.error("Error general en carga en segundo plano:", error);

            // Almacenar estructura de error
            setVizData(prev => ({
                ...prev,
                [id_message]: {
                    data: [],
                    columns: {},
                    query: "",
                    column_types: {},
                    hasError: true,
                    error: "No se puede generar la gráfica en este momento. Por favor, intenta reformular tu pregunta."
                }
            }));
        } finally {
            // Marcar como completado, independientemente del resultado
            setVizLoading(prev => ({
                ...prev,
                [id_message]: false
            }));
        }
    };

    const getQuery = async (id_message) => {
        try {
            // Crear el request autenticado
            const authenticatedRequest = await createAuthenticatedRequest(config);

            // Construir la URL completa con el query parameter
            const url = `${baseURL}${endpoint_get_sql}?id_message=${encodeURIComponent(id_message)}`;

            // Para debug
            /* //console.log('Request URL:', url); */

            // Hacer la petición autenticada
            const response = await authenticatedRequest(
                url,
                'GET',
                null
            );
            //console.log("MENSAJES ANTERIORES REQUEST", url, response.messages)
            return response.messages

        } catch (error) {

            console.error('Error creating new conversation:', error);
            return "None"
        }
    };

    // Add this function to your utilities
    function safeJSONStringify(obj) {
        try {
            return JSON.stringify(obj);
        } catch (error) {
            console.warn("Error en serialización JSON:", error);

            // Approach for handling circular references
            const seen = new WeakSet();
            return JSON.stringify(obj, (key, value) => {
                if (typeof value === 'object' && value !== null) {
                    if (seen.has(value)) {
                        return "[Referencia Circular]";
                    }
                    seen.add(value);
                }
                // Handle non-serializable types
                if (typeof value === 'function') {
                    return "[Función]";
                }
                if (value instanceof Error) {
                    return {
                        errorType: value.name,
                        errorMessage: value.message
                    };
                }
                return value;
            }, 2);
        }
    }

    const sendMessageToClaude = async (mensajes, userContent, botContent) => {
        const apiKey = "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";
        //console.log("MENSAJES", mensajes, "ULTIMA CONSULTA", userContent)
        const mensajes_form = mensajes.map(({ question, query }) => ({ question, query }));
        const content = buildSQLPrompt(userContent, safeJSONStringify(mensajes_form));


        //console.log("MENSAJE FINAL", content)

        return fetch("https://api.anthropic.com/v1/messages", {
            method: "POST",
            headers: {
                "x-api-key": apiKey,
                "anthropic-version": "2023-06-01",
                "content-type": "application/json",
                "anthropic-dangerous-direct-browser-access": "true"
            },
            body: JSON.stringify({
                model: "claude-sonnet-4-20250514",
                max_tokens: 1000,
                messages: [

                    {
                        role: "user",
                        content: content
                    }

                ]
            })
        })
            .then((response) => {
                if (!response.ok) {
                    console.error('Error en la API de Claude:', response.statusText);
                    return null;
                }
                return response.json();
            })
            .then((data) => {

                return data;
            })
            .catch((error) => {
                console.error('Error haciendo la petición:', error);
                return null;
            });
    };

    const executeSQL = async (sqlStatement) => {
        try {
            // Construir la URL completa con el query parameter
            const url = `${baseURLBD}${endpoint_executeSQL}?sqlStatement=${encodeURIComponent(sqlStatement)}`;

            // Para debug
            //console.log('Request URL:', url);

            // Hacer la petición con AbortController para timeout en el navegador
            const controller = new AbortController();
            const timeoutId = setTimeout(() => controller.abort(), 30000); // 30 segundos

            // Hacer la petición
            const response = await fetch(url, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
                signal: controller.signal // Permite abortar la petición
            });

            // Limpiar el timeout
            clearTimeout(timeoutId);

            // Verificar si la respuesta fue exitosa
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            // Parsear la respuesta a JSON
            const data = await response.json();
            //console.log('Response data:', data);

            return data;
        } catch (error) {
            console.error('Error executing SQL query:', error);

            // Determinar el tipo de error para mensajes más informativos
            let errorMessage = "Error al ejecutar la consulta SQL";

            if (error.name === 'AbortError') {
                errorMessage = "La consulta ha excedido el tiempo máximo de ejecución";
            } else if (error.message) {
                errorMessage = error.message;
            }

            return {
                data: [],
                columns: {},
                query: sqlStatement,
                error: errorMessage
            };
        }
    };

    // Modificado para usar datos precargados
    const handleViz = async (id_message) => {
        // Si ya hay datos precargados para este mensaje, simplemente mostrarlos
        if (vizData[id_message]) {
            setModalIsOpen(true);
            setQueryData(vizData[id_message]);
            return;
        }

        // Si todavía está cargando, no hacer nada más que mostrar el modal con estado de carga
        if (vizLoading[id_message]) {
            setModalIsOpen(true);
            setLoading(true);
            return;
        }

        // Si llegamos aquí, no hay datos precargados ni está cargando actualmente
        // Encontrar el mensaje de usuario previo
        const messageIndex = messages.findIndex(msg => msg.id_message === id_message);
        const userMessageIndex = messageIndex > 0 ? messageIndex - 1 : -1;
        const userContent = userMessageIndex >= 0 && messages[userMessageIndex].author === 'Client'
            ? messages[userMessageIndex].content
            : "";
        const botContent = messages[messageIndex].content;

        // Iniciar la visualización normalmente
        setModalIsOpen(true);
        setLoading(true);

        // Obtener la consulta SQL del mensaje o generar una nueva
        const initialQuerySQL = messages[messageIndex]?.query_sql || "Vacio";
        //console.log("Consulta SQL inicial:", initialQuerySQL);

        // Crear instancia del validador y procesar la consulta
        const validator = new SQLValidator();
        let finalQuerySQL = initialQuerySQL;
        let errorMessage = "";
        let attempts = 0;
        const MAX_ATTEMPTS = 2;

        // Estructura base para datos de error
        const errorDataStructure = {
            data: [],
            columns: {},
            query: finalQuerySQL || "",
            column_types: {},
            hasError: true,
            error: "No se puede generar la gráfica. Por favor, intenta reformular tu pregunta."
        };

        try {
            // Si no hay consulta o es "Vacio", obtenerla del agente
            if (!finalQuerySQL || finalQuerySQL === "Vacio") {
                try {
                    let mensajes_anteriores = await getQuery(id_message);
                    //console.log("MENSAJES ANTERIORES (MODAL):", mensajes_anteriores);
                    let respuestaClaude = await sendMessageToClaude(mensajes_anteriores, userContent, botContent);

                    finalQuerySQL = respuestaClaude?.content?.[0]?.text || "";
                    if (!finalQuerySQL) {
                        throw new Error("No se pudo generar una consulta SQL válida");
                    }

                    await updateMessageBD(id_message, finalQuerySQL);
                    //console.log("Consulta generada (MODAL):", finalQuerySQL);
                } catch (genError) {
                    console.error("Error generando consulta (MODAL):", genError);
                    setQueryData({
                        ...errorDataStructure,
                        error: "No se pudo generar la consulta SQL. Por favor, intenta de nuevo con otra pregunta."
                    });
                    setLoading(false);
                    return;
                }
            }

            // Proceso iterativo de validación, corrección y ejecución
            while (attempts < MAX_ATTEMPTS) {
                attempts++;

                try {
                    // Limpiar y validar SQL
                    finalQuerySQL = validator.cleanMarkdown(finalQuerySQL);
                    let validationResult = validator.validate(finalQuerySQL);

                    if (!validationResult.valid || errorMessage) {
                        console.warn(`Intento #${attempts} (MODAL): Validación SQL con errores:`, validationResult.errors, "Error previo:", errorMessage);

                        // Corregir errores
                        const { sql: correctedSQL, wasFixed, fixes } = validator.fixQuery(finalQuerySQL, errorMessage);

                        if (wasFixed) {
                            //console.log(`Consulta corregida en intento #${attempts} (MODAL):`, correctedSQL);
                            //console.log("Correcciones aplicadas (MODAL):", fixes);
                            finalQuerySQL = correctedSQL;
                        } else if (errorMessage) {
                            // Si hay error pero no pudimos corregirlo, terminar el loop
                            console.error("No se pudo corregir el error (MODAL):", errorMessage);
                            break;
                        }
                    }

                    // Ejecutar la consulta SQL corregida
                    //console.log(`Ejecutando consulta (MODAL, intento #${attempts}):`, finalQuerySQL);

                    let records = await executeSQL(finalQuerySQL);

                    // 🔍 VALIDACIÓN MEJORADA: Verificar estructura de datos
                    const validateDataStructure = (records) => {
                        console.log("🔍 DEBUG - Validando estructura de datos:", {
                            recordsExists: !!records,
                            recordsType: typeof records,
                            hasData: !!records?.data,
                            dataType: typeof records?.data,
                            isDataArray: Array.isArray(records?.data),
                            dataLength: records?.data?.length,
                            hasColumns: !!records?.columns,
                            columnsType: typeof records?.columns,
                            columnsKeys: records?.columns ? Object.keys(records.columns) : [],
                            hasError: !!records?.error,
                            error: records?.error
                        });

                        if (!records || typeof records !== 'object') {
                            return { isValid: false, error: "Datos no válidos recibidos del servidor" };
                        }

                        if (records.error) {
                            return { isValid: false, error: records.error };
                        }

                        if (!Array.isArray(records.data)) {
                            return { isValid: false, error: "Formato de datos incorrecto - se esperaba un array" };
                        }

                        if (!records.columns || typeof records.columns !== 'object') {
                            return { isValid: false, error: "Información de columnas faltante o inválida" };
                        }

                        return { isValid: true };
                    };

                    const validation = validateDataStructure(records);
                    console.log("🔍 DEBUG - Resultado de validación de estructura:", validation);

                    if (!validation.isValid) {
                        errorMessage = validation.error;
                        console.error(`🚨 DEBUG - Error de validación en intento #${attempts}:`, errorMessage);

                        // Si es el último intento, preparar mensaje amigable
                        if (attempts >= MAX_ATTEMPTS) {
                            let userFriendlyError = "No se puede generar la gráfica en este momento. ";

                            if (errorMessage.includes("operator does not exist")) {
                                userFriendlyError += "Hay un problema de compatibilidad entre tipos de datos.";
                            } else if (errorMessage.includes("timeout") || errorMessage.includes("exceeded")) {
                                userFriendlyError += "La consulta es demasiado compleja.";
                            } else if (errorMessage.includes("array")) {
                                userFriendlyError += "El formato de los datos no es el esperado.";
                            } else {
                                userFriendlyError += "Ha ocurrido un error al procesar la consulta.";
                            }

                            userFriendlyError += " Por favor, intenta reformular tu pregunta.";

                            console.log("🔍 DEBUG - Guardando error final:", userFriendlyError);

                            // Almacenar el error
                            setVizData(prev => ({
                                ...prev,
                                [id_message]: {
                                    ...errorDataStructure,
                                    query: finalQuerySQL,
                                    error: userFriendlyError
                                }
                            }));
                            break;
                        }

                        continue;
                    }

                    // Verificar si hay errores en la ejecución
                    if (records && records.error) {
                        errorMessage = records.error;
                        console.error(`Error al ejecutar SQL (MODAL, intento #${attempts}):`, errorMessage);

                        // Si es el último intento, mostrar mensaje amigable
                        if (attempts >= MAX_ATTEMPTS) {
                            let userFriendlyError = "No se puede generar la gráfica en este momento. ";

                            if (errorMessage.includes("operator does not exist")) {
                                userFriendlyError += "Hay un problema de compatibilidad entre tipos de datos.";
                            } else if (errorMessage.includes("timeout") || errorMessage.includes("exceeded")) {
                                userFriendlyError += "La consulta es demasiado compleja.";
                            } else {
                                userFriendlyError += "Ha ocurrido un error al procesar la consulta.";
                            }

                            userFriendlyError += " Por favor, intenta reformular tu pregunta.";

                            setQueryData({
                                ...errorDataStructure,
                                query: finalQuerySQL,
                                error: userFriendlyError
                            });
                            break;
                        }

                        continue;
                    }

                    // Si llegamos aquí, la consulta se ejecutó sin errores
                    //console.log(`Consulta ejecutada con éxito (MODAL, intento #${attempts})`);

                    // Validar que records tenga la estructura esperada
                    if (!records || !records.data || !Array.isArray(records.data)) {
                        throw new Error("La respuesta no tiene el formato esperado");
                    }

                    // Actualizar el mensaje con la consulta final
                    setMessages(prevMessages =>
                        prevMessages.map(msg =>
                            msg.id_message === id_message
                                ? { ...msg, query_sql: finalQuerySQL }
                                : msg
                        )
                    );

                    // Actualizar datos para visualización
                    setQueryData({
                        data: records.data || [],
                        columns: records.columns || {},
                        query: finalQuerySQL,
                        column_types: records.column_types || {},
                        hasError: false
                    });

                    setLoading(false);
                    return;
                } catch (loopError) {
                    console.error(`Error en intento #${attempts} (MODAL):`, loopError);
                    errorMessage = loopError.message || "Error desconocido";

                    // Si es el último intento, mostrar mensaje de error
                    if (attempts >= MAX_ATTEMPTS) {
                        setQueryData({
                            ...errorDataStructure,
                            error: "No se puede generar la gráfica. Por favor, intenta nuevamente."
                        });
                    }
                }
            }

        } catch (error) {
            console.error("Error general en handleViz (MODAL):", error);

            setQueryData({
                ...errorDataStructure,
                error: "No se puede generar la gráfica en este momento. Por favor, intenta reformular tu pregunta."
            });
        } finally {
            setLoading(false);
        }
    };

    // Función para extraer datos de tabla markdown y descargar como Excel
    const handleDownloadTableAsExcel = (tableElement) => {
        try {
            // Extraer datos de la tabla
            const rows = tableElement.querySelectorAll('tr');
            const data = [];

            rows.forEach((row, index) => {
                const cells = row.querySelectorAll('th, td');
                const rowData = {};

                cells.forEach((cell, cellIndex) => {
                    const columnName = index === 0 ?
                        cell.textContent.trim() :
                        `Column_${cellIndex + 1}`;

                    if (index === 0) {
                        // Si es la primera fila (headers), usar como nombres de columnas
                        rowData[columnName] = columnName;
                    } else {
                        // Para las demás filas, usar los headers de la primera fila
                        const headers = Array.from(tableElement.querySelectorAll('tr:first-child th, tr:first-child td'));
                        const headerText = headers[cellIndex]?.textContent.trim() || `Column_${cellIndex + 1}`;
                        rowData[headerText] = cell.textContent.trim();
                    }
                });

                if (index > 0) { // Skip header row for data
                    data.push(rowData);
                }
            });

            // Generar timestamp
            const timestamp = new Date().toISOString().replace(/[-:]/g, '').replace(/\..+/, '');

            // Crear y descargar Excel
            const worksheet = XLSX.utils.json_to_sheet(data);
            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, 'Tabla');
            XLSX.writeFile(workbook, `tabla_${timestamp}.xlsx`);

        } catch (error) {
            console.error('Error al descargar tabla:', error);
            alert('Error al generar el archivo Excel');
        }
    };

    const handleGenerateExcel = () => {
        if (!queryData || !queryData.data) {
            console.error('No hay datos disponibles para generar el Excel.');
            return;
        }

        // Obtener timestamp
        const timestamp = new Date().toISOString().replace(/[-:]/g, '').replace(/\..+/, '');

        // Generar el archivo Excel
        const worksheet = XLSX.utils.json_to_sheet(queryData.data); // Convierte los datos a formato Excel
        const workbook = XLSX.utils.book_new(); // Crea un nuevo libro
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Datos'); // Agrega la hoja de datos
        XLSX.writeFile(workbook, `resultado_${timestamp}.xlsx`); // Descarga el archivo con timestamp
    };

    /* --------------- ---------------  ---------------  Petición de bedrock --------------- ---------------  ---------------  */

    const createAuthenticatedRequest = async (config) => {
        // Obtener el token de ID de la sesión actual
        const authToken = (await fetchAuthSession()).tokens?.idToken?.toString();
        const my_login = 'cognito-idp.' + config.aws_project_region + '.amazonaws.com/' + config.aws_user_pools_id;

        // Obtener credenciales del Identity Pool
        const credentials = fromCognitoIdentityPool({
            clientConfig: { region: config.aws_project_region },
            identityPoolId: config.aws_cognito_identity_pool_id,
            logins: { [my_login]: authToken }
        });

        // Crear el firmante para las peticiones
        const signer = new SignatureV4({
            credentials: credentials,
            region: config.aws_project_region,
            service: 'execute-api',
            sha256: Sha256
        });

        // Función para hacer peticiones firmadas
        return async (endpoint, method = 'GET', body = null) => {
            const url = new URL(endpoint);

            const request = new HttpRequest({
                hostname: url.hostname,
                path: url.pathname + url.search,
                method: method,
                headers: {
                    'Content-Type': 'application/json',
                    host: url.hostname
                },
                body: body ? JSON.stringify(body) : undefined
            });

            // Firmar la petición
            const signedRequest = await signer.sign(request);

            // Hacer la petición HTTP
            const fetchOptions = {
                method: signedRequest.method,
                headers: signedRequest.headers,
                body: signedRequest.body
            };

            const response = await fetch(url.toString(), fetchOptions);
            return response.json();
        };
    };

    // Funciones de Bedrock
    const invokeBedrockAgent = async (prompt, sessionId, id_message_bot) => {
        const authToken = (await fetchAuthSession()).tokens?.idToken?.toString();
        const my_login = 'cognito-idp.' + config.aws_project_region + '.amazonaws.com/' + config.aws_user_pools_id
        const bedrock = new BedrockAgentRuntimeClient({
            region: config.aws_project_region,
            credentials: fromCognitoIdentityPool({
                clientConfig: { region: config.aws_project_region },
                identityPoolId: config.aws_cognito_identity_pool_id,
                logins: { [my_login]: authToken }
            })
        });

        const input = {
            agentId: AGENT_ID,
            agentAliasId: AGENT_ALIAS_ID,
            sessionId,
            inputText: prompt,
            enableTrace: true,
            sessionState: {
                sessionAttributes: {
                    id_message: id_message_bot
                }
            }
        };

        const command = new InvokeAgentCommand(input);
        let completion = "";
        let runningTraces = [];

        // Variables para contar tokens
        let totalInputTokens = 0;
        let totalOutputTokens = 0;
        let tokenUsageDetails = [];

        const response = await bedrock.send(command);
        if (response.completion === undefined) {
            throw new Error("Completion is undefined");
        }

        for await (let chunkEvent of response.completion) {
            if (chunkEvent.chunk) {
                const chunk = chunkEvent.chunk;
                const decodedResponse = new TextDecoder("utf-8").decode(chunk.bytes);
                completion += decodedResponse;
            }

            if (chunkEvent.trace) {
                runningTraces = [...runningTraces, chunkEvent.trace];

                // Función auxiliar para extraer tokens de cualquier parte del trace
                const extractTokensFromTrace = (trace, traceType = 'general') => {
                    if (trace && trace.orchestrationTrace) {
                        const orchTrace = trace.orchestrationTrace;

                        // Buscar en modelInvocationOutput
                        if (orchTrace.modelInvocationOutput &&
                            orchTrace.modelInvocationOutput.metadata &&
                            orchTrace.modelInvocationOutput.metadata.usage) {

                            const usage = orchTrace.modelInvocationOutput.metadata.usage;
                            const inputTokens = usage.inputTokens || 0;
                            const outputTokens = usage.outputTokens || 0;

                            totalInputTokens += inputTokens;
                            totalOutputTokens += outputTokens;

                            tokenUsageDetails.push({
                                step: tokenUsageDetails.length + 1,
                                type: 'model_invocation',
                                traceType: traceType,
                                inputTokens: inputTokens,
                                outputTokens: outputTokens,
                                totalTokens: inputTokens + outputTokens,
                                traceId: trace.traceId || 'unknown',
                                timestamp: new Date().toISOString()
                            });
                        }

                        // Buscar en knowledgeBaseLookupOutput
                        if (orchTrace.knowledgeBaseLookupOutput &&
                            orchTrace.knowledgeBaseLookupOutput.metadata &&
                            orchTrace.knowledgeBaseLookupOutput.metadata.usage) {

                            const usage = orchTrace.knowledgeBaseLookupOutput.metadata.usage;
                            const inputTokens = usage.inputTokens || 0;
                            const outputTokens = usage.outputTokens || 0;

                            totalInputTokens += inputTokens;
                            totalOutputTokens += outputTokens;

                            tokenUsageDetails.push({
                                step: tokenUsageDetails.length + 1,
                                type: 'knowledge_base',
                                traceType: traceType,
                                inputTokens: inputTokens,
                                outputTokens: outputTokens,
                                totalTokens: inputTokens + outputTokens,
                                traceId: trace.traceId || 'unknown',
                                timestamp: new Date().toISOString()
                            });
                        }

                        // Buscar en invocationInput si existe
                        if (orchTrace.invocationInput &&
                            orchTrace.invocationInput.actionGroupInvocationInput) {
                            // Marcar que se usó una action group (puede consumir tokens)
                            tokenUsageDetails.push({
                                step: tokenUsageDetails.length + 1,
                                type: 'action_group',
                                traceType: traceType,
                                inputTokens: 0,
                                outputTokens: 0,
                                totalTokens: 0,
                                note: 'Action group invocation detected',
                                traceId: trace.traceId || 'unknown',
                                timestamp: new Date().toISOString()
                            });
                        }
                    }
                };

                // Extraer tokens del trace
                const trace = chunkEvent.trace.trace;
                extractTokensFromTrace(trace, 'main');
            }
        }

        // Crear resumen de tokens con estimación de costo (aproximado)
        const tokenSummary = {
            totalInputTokens,
            totalOutputTokens,
            totalTokens: totalInputTokens + totalOutputTokens,
            // Estimación aproximada de costo (varies by model)
            estimatedCost: {
                note: "Estimation only - check AWS pricing for accurate costs",
                inputCost: (totalInputTokens / 1000) * 0.003, // Aproximado para Claude
                outputCost: (totalOutputTokens / 1000) * 0.015, // Aproximado para Claude
                totalCost: ((totalInputTokens / 1000) * 0.003) + ((totalOutputTokens / 1000) * 0.015)
            },
            breakdown: {
                modelInvocations: tokenUsageDetails.filter(d => d.type === 'model_invocation').length,
                knowledgeBaseQueries: tokenUsageDetails.filter(d => d.type === 'knowledge_base').length,
                actionGroupCalls: tokenUsageDetails.filter(d => d.type === 'action_group').length
            },
            details: tokenUsageDetails
        };

        console.log("RESUMEN DE TOKENS:", tokenSummary);
        console.log("COMPLETION:", completion);
        console.log("TRACES:", runningTraces);

        return {
            completion,
            runningTraces,
            tokenUsage: tokenSummary
        };
    };

    const handleInvokeAgent = async (message, sessionId, id_message_bot) => {
        try {
            const result = await invokeBedrockAgent(message, sessionId, id_message_bot);
            setResponse(result.completion); // Update state with the response

            // Iniciar la precarga de la visualización después de recibir la respuesta
            // Marcar el mensaje como en proceso de carga de visualización
            setVizLoading(prev => ({
                ...prev,
                [id_message_bot]: true
            }));

            // Iniciar la carga de la visualización en segundo plano
            loadVisualizationInBackground(id_message_bot, "Vacio", message, result.completion);

            // Generar nuevas preguntas sugeridas basadas en esta interacción
            getSuggestedQuestions(message, result.completion);

            return result.completion;
        } catch (error) {
            console.error("Error invoking agent:", error);
        }
    };

    // Componente separado para tabla con descarga
    // Componente separado para tabla con descarga
    // Componente separado para tabla con descarga (ACTUALIZADO)
    const MarkdownTableWithDownload = ({ children }) => {
        const tableRef = useRef(null);

        const handleDownloadTable = () => {
            console.log("Descargando tabla...");
            handleDownloadTableAsExcel(tableRef.current);
        };

        return (
            <div className="markdown-table-wrapper">
                <div className="table-header">
                    <button
                        className="download-table-btn"
                        onClick={handleDownloadTable}
                        title="Descargar tabla como Excel"
                    >
                        <FaFileExcel size={12} />
                        Descargar
                    </button>
                </div>
                <div className="markdown-table-container">
                    <table className="markdown-table" ref={tableRef}>
                        {children}
                    </table>
                </div>
            </div>
        );
    };
    /* --------------- Función enviar formulario --------------- */
    // FUNCIÓN HANDLESUBMIT CORREGIDA - Reemplazar la función completa

    const handleSubmit = async (event) => {
        event.preventDefault();
        if (!message.trim()) return;

        let finalQuery = message;
        let webSearchContext = "";
        let imageAnalysisContext = "";
        let firstAgentMessageId = null;
        let bedrockMessageId = null;

        // Flags para rastrear qué tipo de procesamiento se hizo
        let hasImageProcessing = false;
        let hasWebSearchProcessing = false;

        if (imageFile) {
            console.log('Procesando imagen para análisis...');
            hasImageProcessing = true;

            try {
                // Agregar mensaje del cliente solo con texto (sin imagen)
                addMessage('Client', message);
                setMessage('');
                adjustTextareaHeight(messageInputRef.current);

                // Crear ID para el mensaje de análisis de imagen
                firstAgentMessageId = Date.now();

                // Mostrar mensaje de análisis de imagen
                const imageAnalysisMessage = {
                    author: 'Bot',
                    content: (
                        <div className="image-analysis-progress">
                            <span className="thinking-dots">
                                🔍 Analizando imagen...
                            </span>
                            <div style={{ fontSize: '12px', color: '#888', marginTop: '4px' }}>
                                Extrayendo información relevante de la imagen
                            </div>
                        </div>
                    ),
                    type: 'text',
                    data: null,
                    id: firstAgentMessageId,
                    temp: true,
                    isImageAnalysisMessage: true,
                    isPreviewMessage: true // 🔧 MARCAR COMO PREVIEW
                };
                setMessages(prevMessages => [...prevMessages, imageAnalysisMessage]);

                // 🔧 MEJORAR SCROLL
                setTimeout(() => {
                    scrollToBottom();
                }, 200);

                // Guardar referencias antes de limpiar
                const imageToAnalyze = imageFile;
                const userPrompt = message.trim();

                // Limpiar imagen después de mostrar el mensaje
                clearImage();

                // Realizar análisis de imagen
                imageAnalysisContext = await performImageAnalysis(imageToAnalyze, userPrompt);

                // Verificar si el análisis de imagen fue exitoso
                if (imageAnalysisContext && !imageAnalysisContext.includes("Error")) {
                    finalQuery = `INFORMACIÓN EXTRAÍDA DE LA IMAGEN:
                ${imageAnalysisContext}

                CONSULTA ORIGINAL DEL USUARIO:
                ${userPrompt}

                Por favor, utiliza la información extraída de la imagen junto con nuestros datos internos para proporcionar una respuesta completa y relevante a la consulta del usuario.`;
                } else {
                    finalQuery = userPrompt;
                    imageAnalysisContext = "";
                }

                // FINALIZAR el mensaje de análisis de imagen
                setMessages(prevMessages =>
                    prevMessages.map(msg =>
                        msg.id === firstAgentMessageId ? {
                            ...msg,
                            content: (
                                <div>
                                    {imageAnalysisContext && !imageAnalysisContext.includes("Error") ? (
                                        <div className="image-info-card">
                                            <strong>🔍 Imagen analizada correctamente</strong>
                                            <div className="image-info-content">
                                                {imageAnalysisContext}
                                            </div>
                                        </div>
                                    ) : (
                                        <div className="image-analysis-error">
                                            <strong>⚠️ Error al analizar imagen</strong>
                                            <div style={{ marginTop: "5px", fontSize: "0.9em" }}>
                                                Continuando con análisis de datos internos...
                                            </div>
                                        </div>
                                    )}
                                </div>
                            ),
                            temp: false,
                            isImageAnalysisMessage: true,
                            isPreviewMessage: true // 🔧 MANTENER COMO PREVIEW
                        } : msg
                    )
                );

                // 🔧 SCROLL DESPUÉS DE FINALIZAR
                setTimeout(() => {
                    scrollToBottom();
                }, 200);

            } catch (imageError) {
                console.error('Error en análisis de imagen:', imageError);

                // Finalizar mensaje de análisis con error
                setMessages(prevMessages =>
                    prevMessages.map(msg =>
                        msg.id === firstAgentMessageId ? {
                            ...msg,
                            content: (
                                <div className="image-analysis-error">
                                    <strong>⚠️ No se pudo analizar la imagen</strong>
                                    <div style={{ marginTop: "5px", fontSize: "0.9em" }}>
                                        Continuando con análisis de datos internos...
                                    </div>
                                </div>
                            ),
                            temp: false,
                            isImageAnalysisMessage: true,
                            isPreviewMessage: true // 🔧 MARCAR COMO PREVIEW
                        } : msg
                    )
                );

                finalQuery = message;
            }

        } else if (webSearchEnabled) {
            hasWebSearchProcessing = true;

            try {
                addMessage('Client', message);
                setMessage('');
                adjustTextareaHeight(messageInputRef.current);

                // Crear ID para el mensaje de búsqueda web
                firstAgentMessageId = Date.now();

                // Mostrar mensaje de búsqueda web
                const webSearchMessage = {
                    author: 'Bot',
                    content: (
                        <span className="thinking-dots">
                            <FaGlobe style={{ marginRight: "5px" }} />
                            Buscando información actualizada en la web...
                        </span>
                    ),
                    type: 'text',
                    data: null,
                    id: firstAgentMessageId,
                    temp: true,
                    isWebSearchMessage: true,
                    isPreviewMessage: true // 🔧 MARCAR COMO PREVIEW
                };
                setMessages(prevMessages => [...prevMessages, webSearchMessage]);

                // 🔧 MEJORAR SCROLL
                setTimeout(() => {
                    scrollToBottom();
                }, 200);

                // Realizar búsqueda web
                webSearchContext = await performWebSearch(message);

                // Verificar si la búsqueda web encontró información útil
                if (webSearchContext.includes("No se requiere búsqueda web") ||
                    webSearchContext.includes("No se pudo encontrar información")) {

                    finalQuery = message;
                    webSearchContext = "";

                } else {
                    finalQuery = `INFORMACIÓN EXTERNA COMPLEMENTARIA:
                ${webSearchContext}

                CONSULTA ORIGINAL DEL USUARIO:
                ${message}

                Por favor, utiliza la información externa proporcionada junto con nuestros datos internos para dar una respuesta más completa y actualizada.`;
                }

                // FINALIZAR el mensaje de búsqueda web
                setMessages(prevMessages =>
                    prevMessages.map(msg =>
                        msg.id === firstAgentMessageId ? {
                            ...msg,
                            content: (
                                <div>
                                    {webSearchContext && !webSearchContext.includes("No se requiere búsqueda web") && !webSearchContext.includes("No se pudo encontrar información") ? (
                                        <div className="web-info-card">
                                            <strong><FaGlobe style={{ marginRight: "5px" }} />Información externa encontrada</strong>
                                            <div className="web-info-content">
                                                {webSearchContext}
                                            </div>
                                        </div>
                                    ) : webSearchContext.includes("No se requiere búsqueda web") ? (
                                        <div className="web-search-success">
                                            <strong><FaGlobe style={{ marginRight: "5px" }} />Búsqueda web no necesaria</strong>
                                            <div style={{ marginTop: "5px", fontSize: "0.9em" }}>
                                                La consulta puede responderse completamente con datos internos
                                            </div>
                                        </div>
                                    ) : (
                                        <div className="web-search-loading">
                                            <strong><FaGlobe style={{ marginRight: "5px" }} />Información externa no encontrada</strong>
                                            <div style={{ marginTop: "5px", fontSize: "0.9em" }}>
                                                Continuando con análisis de datos internos...
                                            </div>
                                        </div>
                                    )}
                                </div>
                            ),
                            temp: false,
                            isWebSearchMessage: true,
                            isPreviewMessage: true // 🔧 MANTENER COMO PREVIEW
                        } : msg
                    )
                );

                // 🔧 SCROLL DESPUÉS DE FINALIZAR
                setTimeout(() => {
                    scrollToBottom();
                }, 200);

            } catch (webError) {
                console.error('Error en búsqueda web:', webError);

                // Finalizar mensaje de búsqueda con error
                setMessages(prevMessages =>
                    prevMessages.map(msg =>
                        msg.id === firstAgentMessageId ? {
                            ...msg,
                            content: (
                                <div className="web-search-error">
                                    <strong>⚠️ Búsqueda web no disponible</strong>
                                    <div style={{ marginTop: "5px", fontSize: "0.9em" }}>
                                        Continuando con análisis de datos internos...
                                    </div>
                                </div>
                            ),
                            temp: false,
                            isWebSearchMessage: true,
                            isPreviewMessage: true // 🔧 MARCAR COMO PREVIEW
                        } : msg
                    )
                );

                finalQuery = message;
            }

        } else {
            // Flujo normal sin búsqueda web ni imagen
            addMessage('Client', message);
            setMessage('');
            adjustTextareaHeight(messageInputRef.current);
        }

        // 🔥 CREAR NUEVO MENSAJE PARA BEDROCK
        bedrockMessageId = Date.now() + 1;

        const bedrockLoadingMessage = {
            author: 'Bot',
            content: (
                <span className="thinking-dots">
                    🤖 Procesando con inteligencia artificial...
                </span>
            ),
            type: 'text',
            data: null,
            id: bedrockMessageId,
            temp: true,
            isBedrockMessage: true,
            isPreviewMessage: false // 🔧 NO ES PREVIEW
        };

        setMessages(prevMessages => [...prevMessages, bedrockLoadingMessage]);

        // 🔧 SCROLL MEJORADO
        setTimeout(() => {
            scrollToBottom();
        }, 200);

        // PROCESAR BEDROCK Y RESPUESTA FINAL
        try {
            let id_message_client = uuidv4();
            let response_message_client = await addMessageBD(id_conversation, id_user, message, "Client", id_message_client);

            let id_message_bot = uuidv4();

            // Enviar la consulta al agente de Bedrock
            let responseBedrock = await handleInvokeAgent(finalQuery, id_conversation, id_message_bot);

            if (responseBedrock === undefined || responseBedrock === "Sorry, I am unable to assist you with this request.") {
                const claudeSuggestions = await consultClaude(
                    message,
                    "El servidor no pudo procesar esta consulta. Posiblemente sea demasiado compleja o contenga elementos no soportados."
                );

                if (claudeSuggestions) {
                    responseBedrock = `La consulta no puede procesarse en este momento. Aquí hay algunas alternativas que podrías intentar:\n\n${claudeSuggestions}\n\nSelecciona una de estas alternativas o reformula tu consulta de otra manera.`;
                } else {
                    responseBedrock = "Lo siento, no puedo procesar esta consulta en este momento. Intenta ser más específico o dividir tu pregunta en consultas más simples.";
                }
            }

            let response_message_bot = await addMessageBD(id_conversation, id_user, responseBedrock, "Bot", id_message_bot);

            // 🔧 ELIMINAR MENSAJE PREVIEW Y ACTUALIZAR BEDROCK
            setMessages(prevMessages => {
                // Filtrar el mensaje preview
                const filteredMessages = prevMessages.filter(msg =>
                    !(msg.isPreviewMessage && (msg.id === firstAgentMessageId))
                );

                // Actualizar el mensaje de Bedrock
                return filteredMessages.map(msg =>
                    msg.id === bedrockMessageId ? {
                        ...msg,
                        id_message: id_message_bot,
                        text: responseBedrock,
                        content: (
                            <div>
                                {/* Mostrar contexto de imagen si existe */}
                                {hasImageProcessing && imageAnalysisContext &&
                                    !imageAnalysisContext.includes("Error") && (
                                        <div className="image-context-container">
                                            <details>
                                                <summary>
                                                    🔍 Información extraída de la imagen (click para ver)
                                                </summary>
                                                <div className="image-context-content">
                                                    <ReactMarkdown>{imageAnalysisContext}</ReactMarkdown>
                                                </div>

                                            </details>
                                        </div>
                                    )}

                                {/* Mostrar contexto web si existe */}
                                {hasWebSearchProcessing && webSearchContext &&
                                    !webSearchContext.includes("No se requiere búsqueda web") &&
                                    !webSearchContext.includes("No se pudo encontrar información") && (
                                        <div className="web-context-container">
                                            <details>
                                                <summary>
                                                    <FaGlobe style={{ marginRight: "5px" }} />
                                                    Información externa utilizada (click para ver)
                                                </summary>
                                                <div className="web-context-content">
                                                    <ReactMarkdown>{webSearchContext}</ReactMarkdown>
                                                </div>
                                            </details>
                                        </div>
                                    )}

                                {/* Respuesta principal */}


                                <ReactMarkdown
                                    remarkPlugins={[remarkGfm]} // IMPORTANTE: Agregar esto
                                    components={{
                                        // Código existente
                                        code({ node, inline, className, children, ...props }) {
                                            const match = /language-(\w+)/.exec(className || '');
                                            return !inline && match ? (
                                                <SyntaxHighlighter
                                                    style={tomorrow}
                                                    language={match[1]}
                                                    PreTag="div"
                                                    {...props}
                                                >
                                                    {String(children).replace(/\n$/, '')}
                                                </SyntaxHighlighter>
                                            ) : (
                                                <code className={className} {...props}>
                                                    {children}
                                                </code>
                                            );
                                        },
                                        // NUEVO: Componentes para tablas
                                        // NUEVO: Componente para tablas simplificado
                                        table({ children }) {
                                            return <MarkdownTableWithDownload>{children}</MarkdownTableWithDownload>;
                                        },
                                        thead({ children }) {
                                            return <thead className="markdown-thead">{children}</thead>;
                                        },
                                        tbody({ children }) {
                                            return <tbody className="markdown-tbody">{children}</tbody>;
                                        },
                                        tr({ children }) {
                                            return <tr className="markdown-tr">{children}</tr>;
                                        },
                                        th({ children, style }) {
                                            return (
                                                <th className="markdown-th" style={style}>
                                                    {children}
                                                </th>
                                            );
                                        },
                                        td({ children, style }) {
                                            return (
                                                <td className="markdown-td" style={style}>
                                                    {children}
                                                </td>
                                            );
                                        },
                                        // Mantener los demás componentes existentes
                                        h1: ({ children }) => <h1 style={{ color: '#333', marginBottom: '10px' }}>{children}</h1>,
                                        h2: ({ children }) => <h2 style={{ color: '#555', marginBottom: '8px' }}>{children}</h2>,
                                        h3: ({ children }) => <h3 style={{ color: '#777', marginBottom: '6px' }}>{children}</h3>,
                                        p: ({ children }) => <p style={{ marginBottom: '10px', lineHeight: '1.6' }}>{children}</p>,
                                        ul: ({ children }) => <ul style={{ marginLeft: '20px', marginBottom: '10px' }}>{children}</ul>,
                                        ol: ({ children }) => <ol style={{ marginLeft: '20px', marginBottom: '10px' }}>{children}</ol>,
                                        li: ({ children }) => <li style={{ marginBottom: '5px' }}>{children}</li>,
                                        blockquote: ({ children }) => (
                                            <blockquote style={{
                                                borderLeft: '4px solid #ddd',
                                                paddingLeft: '15px',
                                                margin: '10px 0',
                                                fontStyle: 'italic',
                                                color: '#666'
                                            }}>
                                                {children}
                                            </blockquote>
                                        )
                                    }}
                                >
                                    {responseBedrock}
                                </ReactMarkdown>
                            </div>
                        ),
                        temp: false,
                        isPreviewMessage: false // 🔧 NO ES PREVIEW
                    } : msg
                );
            });

            // 🔧 SCROLL FINAL MEJORADO
            setTimeout(() => {
                scrollToBottom();
            }, 300);

        } catch (error) {
            console.error('Error fetching data:', error);

            try {
                const claudeSuggestions = await consultClaude(
                    message,
                    `Error técnico: ${error.message || "Error de conexión"}`
                );

                const errorMessage = claudeSuggestions
                    ? `Hubo un problema con la conexión al servidor. Mientras tanto, puedes intentar con estas alternativas:\n\n${claudeSuggestions}`
                    : "Hubo un problema con la conexión al servidor. Intenta con otra consulta o verifica tu conexión.";

                // 🔧 ELIMINAR PREVIEW Y MOSTRAR ERROR
                setMessages(prevMessages => {
                    const filteredMessages = prevMessages.filter(msg =>
                        !(msg.isPreviewMessage && (msg.id === firstAgentMessageId))
                    );

                    return filteredMessages.map(msg =>
                        msg.id === bedrockMessageId ? {
                            ...msg,
                            content: errorMessage,
                            temp: false,
                            isPreviewMessage: false
                        } : msg
                    );
                });
            } catch (claudeError) {
                setMessages(prevMessages => {
                    const filteredMessages = prevMessages.filter(msg =>
                        !(msg.isPreviewMessage && (msg.id === firstAgentMessageId))
                    );

                    return filteredMessages.map(msg =>
                        msg.id === bedrockMessageId ? {
                            ...msg,
                            content: "Hubo un problema con la conexión al servidor. Intenta con otra consulta o verifica tu conexión.",
                            temp: false,
                            isPreviewMessage: false
                        } : msg
                    );
                });
            }
        }
    };

    // Interfaz
    return (
        <div className="chat-container">
            <div className="messages-box">
                <ul className="messages-list">
                    {messages.map((msg, index) => (
                        <li key={index} className={`message ${msg.author === 'Bot' ? 'received' : 'sent'}`}>
                            <div className="message-text">
                                {msg.author === 'Bot' && <img src={botIcon} alt="Bot Icon" className="bot-icon" />}
                                <div className="message-content">
                                    <div className={hoverButtonIndex === index ? "pre-with-padding" : ""}>
                                        {typeof msg.content === 'string' ? (
                                            // Busca TODOS los lugares donde tienes <ReactMarkdown> y reemplázalos con esta estructura:

                                            <ReactMarkdown
                                                remarkPlugins={[remarkGfm]} // IMPORTANTE: Agregar esto
                                                components={{
                                                    // Código existente
                                                    code({ node, inline, className, children, ...props }) {
                                                        const match = /language-(\w+)/.exec(className || '');
                                                        return !inline && match ? (
                                                            <SyntaxHighlighter
                                                                style={tomorrow}
                                                                language={match[1]}
                                                                PreTag="div"
                                                                {...props}
                                                            >
                                                                {String(children).replace(/\n$/, '')}
                                                            </SyntaxHighlighter>
                                                        ) : (
                                                            <code className={className} {...props}>
                                                                {children}
                                                            </code>
                                                        );
                                                    },
                                                    // NUEVO: Componentes para tablas
                                                    // ESTE SÍ está bien
                                                    table({ children }) {
                                                        return <MarkdownTableWithDownload>{children}</MarkdownTableWithDownload>;
                                                    },
                                                    thead({ children }) {
                                                        return <thead className="markdown-thead">{children}</thead>;
                                                    },
                                                    tbody({ children }) {
                                                        return <tbody className="markdown-tbody">{children}</tbody>;
                                                    },
                                                    tr({ children }) {
                                                        return <tr className="markdown-tr">{children}</tr>;
                                                    },
                                                    th({ children, style }) {
                                                        return (
                                                            <th className="markdown-th" style={style}>
                                                                {children}
                                                            </th>
                                                        );
                                                    },
                                                    td({ children, style }) {
                                                        return (
                                                            <td className="markdown-td" style={style}>
                                                                {children}
                                                            </td>
                                                        );
                                                    },
                                                    // Mantener los demás componentes existentes
                                                    h1: ({ children }) => <h1 style={{ color: '#333', marginBottom: '10px' }}>{children}</h1>,
                                                    h2: ({ children }) => <h2 style={{ color: '#555', marginBottom: '8px' }}>{children}</h2>,
                                                    h3: ({ children }) => <h3 style={{ color: '#777', marginBottom: '6px' }}>{children}</h3>,
                                                    p: ({ children }) => <p style={{ marginBottom: '10px', lineHeight: '1.6' }}>{children}</p>,
                                                    ul: ({ children }) => <ul style={{ marginLeft: '20px', marginBottom: '10px' }}>{children}</ul>,
                                                    ol: ({ children }) => <ol style={{ marginLeft: '20px', marginBottom: '10px' }}>{children}</ol>,
                                                    li: ({ children }) => <li style={{ marginBottom: '5px' }}>{children}</li>,
                                                    blockquote: ({ children }) => (
                                                        <blockquote style={{
                                                            borderLeft: '4px solid #ddd',
                                                            paddingLeft: '15px',
                                                            margin: '10px 0',
                                                            fontStyle: 'italic',
                                                            color: '#666'
                                                        }}>
                                                            {children}
                                                        </blockquote>
                                                    )
                                                }}
                                            >
                                                {msg.content}
                                            </ReactMarkdown>
                                        ) : (
                                            msg.content
                                        )}
                                    </div>

                                    {/* Botón para mensajes del bot (visualizar) */}
                                    {msg.author === 'Bot' && !msg.temp && !msg.isPreviewMessage && (
                                        <button
                                            onClick={() => handleViz(msg.id_message)}
                                            className="btn btn-visualize"
                                            disabled={vizLoading[msg.id_message]}
                                        >
                                            {vizLoading[msg.id_message] ? (
                                                <><FaSpinner className="fa-spin" style={{ marginRight: "5px" }} /> Cargando datos...</>
                                            ) : (
                                                <><FaChartLine style={{ marginRight: "5px" }} /> Visualizar Datos</>
                                            )}
                                        </button>
                                    )}

                                    {/* Opciones para mensajes del usuario */}
                                    {msg.author === 'Client' && (
                                        <div className="message-options-container">
                                            <button
                                                className="message-options-btn"
                                                onClick={(e) => handleOptionsClick(index, e)}
                                                onMouseEnter={() => handleButtonMouseEnter(index)}
                                                onMouseLeave={handleButtonMouseLeave}
                                                title="Opciones"
                                            >
                                                <FaEllipsisV size={14} />
                                            </button>

                                            {activeOptionsMenu === index && (
                                                <div className="message-options-menu" onClick={(e) => e.stopPropagation()}>
                                                    <button
                                                        className="message-option-item"
                                                        onClick={() => handleSaveConsult(msg.content)}
                                                        disabled={savingConsult}
                                                    >
                                                        {savingConsult ? (
                                                            <><FaSpinner className="fa-spin" style={{ marginRight: "5px" }} /> Guardando...</>
                                                        ) : (
                                                            <><FaBookmark style={{ marginRight: "5px" }} /> Guardar consulta</>
                                                        )}
                                                    </button>
                                                </div>
                                            )}
                                        </div>
                                    )}
                                </div>
                            </div>
                        </li>
                    ))}
                </ul>
                <div ref={messagesEndRef} />
            </div>

            <div className={`form-container`}>
                {/* Carrusel de preguntas sugeridas */}
                <div className="suggested-questions-carousel-container">
                    <div className="suggested-questions-carousel" ref={carouselRef}>
                        {loadingSuggestions ? (
                            <div className="loading-suggestions">
                                <FaSpinner className="fa-spin" style={{ marginRight: "5px" }} />
                                Generando sugerencias...
                            </div>
                        ) : (
                            <div className="carousel-track">
                                {suggestedQuestions.map((question, idx) => (
                                    <div
                                        key={idx}
                                        className="suggested-question"
                                        onClick={() => handleSuggestedQuestion(question)}
                                    >
                                        {question}
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>
                </div>

                {/* Formulario con botón de búsqueda web */}
                <form className="message-form" onSubmit={handleSubmit}>
                    {/* botón adjuntar imagen */}
                    <input
                        type="file"
                        accept="image/*"
                        ref={imageInputRef}
                        style={{ display: 'none' }}
                        onChange={handleImageChange}
                    />

                    <div className="clip-container">
                        <button
                            type="button"
                            className="clip-button tooltip"
                            data-tooltip="Adjuntar imagen"
                            onClick={(e) => {
                                e.preventDefault();
                                imageInputRef.current?.click();
                            }}
                            title="Adjuntar imagen"
                            disabled={loading}
                        >
                            <FaPaperclip />
                        </button>

                        {/* Preview pequeño al lado del clip */}
                        {imagePreview && (
                            <div className="mini-image-preview">
                                <img
                                    src={imagePreview}
                                    alt="Preview"
                                    className="mini-preview-img"
                                />
                                <button
                                    type="button"
                                    className="mini-remove-btn"
                                    onClick={(e) => {
                                        e.preventDefault();
                                        e.stopPropagation();
                                        clearImage();
                                    }}
                                    title="Eliminar imagen"
                                >
                                    <FaTimes size={8} />
                                </button>
                            </div>
                        )}
                    </div>

                    {/* botón búsqueda web (sin cambios) */}
                    <button
                        type="button"
                        onClick={toggleWebSearch}
                        className={`btn btn-web-search ${webSearchEnabled ? 'active' : ''}`}
                        title={webSearchEnabled ? 'Búsqueda web activada' : 'Activar búsqueda web'}
                        disabled={webSearchLoading}
                    >
                        {webSearchLoading ? <FaSpinner className="fa-spin" /> :
                            webSearchEnabled ? <FaGlobeAmericas /> : <FaGlobe />}
                    </button>

                    <textarea
                        ref={messageInputRef}
                        className="message-input"
                        placeholder="Escribe tu consulta..."
                        value={message}
                        onChange={handleTextareaChange}
                        rows={1}
                        onKeyDown={e => { if (e.key === 'Enter' && !e.shiftKey) { e.preventDefault(); handleSubmit(e); } }}
                    />

                    <button type="submit" className="btn btn-send"><FaArrowUp /></button>
                </form>



                {/* Indicador de estado de búsqueda web */}
                {webSearchEnabled && (
                    <div className="web-search-indicator">
                        <FaGlobe style={{ marginRight: "5px" }} />
                        Búsqueda web activada - Se consultará información actualizada antes del análisis
                    </div>
                )}

                <p className="disclaimer">
                    Aunque analizo datos rápidamente, la decisión final es tuya. <br />
                    Mis sugerencias son solo orientativas, revisa cuidadosamente antes de actuar.
                </p>
            </div>

            {/* Modal existente */}
            <Modal
                isOpen={modalIsOpen}
                onRequestClose={() => setModalIsOpen(false)}
                contentLabel="Data Visualization Modal"
                className="custom-modal"
                overlayClassName="custom-overlay"
            >
                <div className="modal-content">
                    <h2 style={{ margin: "0", padding: "0" }}>Data Visualization</h2>

                    {loading ? (
                        <div className="loader-container">
                            <div className="loader"></div>
                            <p>Cargando datos, por favor espera...</p>
                        </div>
                    ) : (
                        <>
                            {queryData && (
                                <ChartWithControls
                                    columns={queryData.columns || []}
                                    data={queryData.data || []}
                                    column_types={queryData.column_types || {}}
                                    hasError={queryData.hasError || false}
                                    error={queryData.error || null}
                                />
                            )}

                            {queryData && queryData.data && !queryData.hasError && !queryData.error && (
                                <div style={{ textAlign: 'right', marginBottom: '10px', display: "flex", justifyContent: "end" }}>
                                    <button onClick={handleGenerateExcel} className="btn btn-excel">
                                        <FaFileExcel /> Descargar Excel
                                    </button>
                                </div>
                            )}

                            {queryData && queryData.data && Array.isArray(queryData.data) &&
                                queryData.data.length > 0 && !queryData.hasError && !queryData.error && (
                                    <DataTable columns={queryData.columns || []} data={queryData.data || []} />
                                )}
                        </>
                    )}
                </div>
            </Modal>
        </div>
    );
};

export default Chatbotui;